export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
           backgroundColor: theme.palette.primary.main,
           display: "flex",
           justifyContent: "center",
           alignItems: "center",
           fontSize: theme.typography.customFontSize[1],
           fontWeight: theme.typography.customFontWeight[2],
           textAlign: "center",
           padding: "8px 15px",
           gap: "3px",
           fontFamily: theme.typography.fontFamily,
           textTransform: "none",
        },
      }
    }
  };
}
